import { apiGet } from '@/store/api';
import { useHelperStore } from '@/store/helperStore';

export async function getTabSequence() {
  const data = await apiGet('helper/tabSequence/');
  useHelperStore().setTabSequence(data);
}
